import { createAction, props } from '@ngrx/store';
import {
  ICategorySearchResult,
  IDefinitionChild,
  ILocalMetadata,
} from '@boma/supplier-portal/shared/entities';

export interface CreateProductZraDetails {
  classificationCode: string;
  taxCode: string;
  taxCodeType: string;
  syncWithZra: boolean;
}

export const addProductImage = createAction(
  '[AddProduct] Add Product Image',
  props<{ file: File }>()
);

export const addProductImageSuccess = createAction(
  '[AddProduct] Add Product Image Success',
  props<{ imageId: string; file: File }>()
);

export const addProductImageFailure = createAction(
  '[AddProduct] Add Product Image Failure',
  props<{ error: any }>()
);

export const addProductRequiredDetails = createAction(
  '[AddProduct] Add Product Required Details',
  props<{ name: any; description: any }>()
);

export const addProductCustomProperties = createAction(
  '[AddProduct] Add Product Custom Property',
  props<{ property: ILocalMetadata[] }>()
);

export const addProductDetails = createAction(
  '[AddProduct] Add Product Details ',
  props<{ barcode: string; active: boolean }>()
);

export const createProduct = createAction(
  '[AddProduct] Create Product',
  props<{ entityId: string; zraDetails?: CreateProductZraDetails }>()
);

export const createProductSuccess = createAction(
  '[AddProduct] Create Product Success',
  props<{ payload: any }>()
);

export const createProductFailure = createAction(
  '[AddProduct] Create Product Failure',
  props<{ error: any }>()
);

export const setBarcode = createAction(
  '[AddProduct] Add Product Barcode',
  props<{ barcode: string }>()
);

export const setUnitOfMeasure = createAction(
  '[AddProduct] Add Product Unit Of Measure',
  props<{ productMeasurement: string }>()
);

export const addCategory = createAction(
  '[AddProduct] Add Product Category',
  props<{ categoryId: string; category: any }>()
);

export const updateCategories = createAction(
  '[AddProduct] Update Product Categories',
  props<{ categoryIds: string[]; categories: ICategorySearchResult[] }>()
);

export const updateDefinitions = createAction(
  '[AddProduct] Add Product Definition',
  props<{ definitions: IDefinitionChild[] }>()
);

export const setBrand = createAction(
  '[AddProduct] Set Product Brand',
  props<{ brandId: string }>()
);

export const setSKU = createAction(
  '[AddProduct] Set Product SKU',
  props<{ sku: string }>()
);

export const setAllowOnline = createAction(
  '[AddProduct] Set Online',
  props<{ value: boolean }>()
);

export const setAllowReseller = createAction(
  '[AddProduct] Set Reseller',
  props<{ value: boolean }>()
);

export const removeCategory = createAction(
  '[AddProduct] Remove Product Category',
  props<{ categoryId: string; category: any }>()
);

export const updateTaxDefinitions = createAction(
  '[AddProduct] Update Product Country Tax Definition',
  props<{ taxDefinitions: string[] }>()
);

// TODO These are still used in admin when updated remove
export const removeCountryTaxDefinition = createAction(
  '[AddProduct] Remove Product Country Tax Defintion',
  props<{ taxDefinition: any }>()
);

export const addCountryTaxDefinition = createAction(
  '[AddProduct] Add Product Country Tax Defintion',
  props<{ taxDefinition: any }>()
);

export const removeCountry = createAction(
  '[AddProduct] Remove Product Country',
  props<{ countryId: string; country: any }>()
);

export const setActiveState = createAction(
  '[AddProduct] Set Product Active',
  props<{ active: boolean }>()
);
